// extracted by mini-css-extract-plugin
export var content = "_om-1";
export var fullScreen = "_om-0";